export default "__VITE_ASSET__BUKTu2IZ__"